/*
 * Ventes Privées — member price + teaser badge (WEBLCFB2C-18 / 24-29).
 *
 * Two jobs:
 * 1) PREVIEW (test phase): when shop metafield vp_mode = 'employees', the guest-facing elements (collection
 *    banner + "-X % membres" teaser badge) are rendered HIDDEN (hidden + data-vp-preview) so the public
 *    never sees them. A browser that opens any page with ?vp_preview=1 gets a cookie; this script then
 *    reveals those elements for that browser only. ?vp_preview=0 clears it. In 'logged_in' (live) the
 *    elements are rendered visible server-side (no preview needed).
 * 2) VARIANT CHANGE: the theme dispatches `variant:change` on the product form with detail.variant, and
 *    its <sale-price>/<compare-at-price> render a strike when compare_at_price > price. A capture-phase
 *    listener (runs before the theme handlers) updates the badge for EVERYONE, and for MEMBERS only
 *    (data-vp-member="true") rewrites detail.variant.price = member / compare_at_price = original so the
 *    theme itself renders the member strike. Member price is always computed from the ORIGINAL in the map
 *    (no double-discount). Guests keep the normal price (only the teaser badge updates).
 */
(function () {
  if (window.__vpMemberPrice) return;
  window.__vpMemberPrice = true;

  // ---- Preview cookie ---------------------------------------------------------------------------
  try {
    var params = new URLSearchParams(window.location.search);
    if (params.has('vp_preview')) {
      var pv = params.get('vp_preview');
      if (pv === '0' || pv === 'false') {
        document.cookie = 'vp_preview=; path=/; max-age=0';
      } else {
        document.cookie = 'vp_preview=1; path=/; max-age=' + (60 * 60 * 24 * 30); // 30 days
      }
    }
  } catch (e) {}

  function hasPreview() {
    return document.cookie.indexOf('vp_preview=1') !== -1;
  }

  function revealPreview() {
    if (!hasPreview()) return;
    document.querySelectorAll('[data-vp-preview]').forEach(function (el) { el.hidden = false; });
  }

  // ---- Variant change ---------------------------------------------------------------------------
  function onVariantChange(e) {
    var variant = e && e.detail && e.detail.variant;
    if (!variant) return;
    var formId = e.target && e.target.id;

    document.querySelectorAll('vp-member-price[data-vp-map]').forEach(function (el) {
      if (formId && el.getAttribute('form') && el.getAttribute('form') !== formId) return;
      var map = {};
      try { map = JSON.parse(el.getAttribute('data-vp-map') || '{}'); } catch (err) {}
      var m = map[String(variant.id)];
      var pct = m && m.p > 0 ? m.p : 0;
      var isMember = el.getAttribute('data-vp-member') === 'true';
      var badge = el.querySelector('[data-vp-badge]');

      if (pct > 0) {
        if (badge) { badge.textContent = '-' + pct + ' % membres'; badge.hidden = false; }
        if (isMember) {
          // Feed member values into the event → the theme's sale-price/compare-at render the strike.
          variant.price = Math.round((m.o * (100 - pct)) / 100);
          variant.compare_at_price = m.o;
        }
        // Guests: leave the price untouched (normal price), only the badge teases the offer.
      } else if (badge) {
        badge.hidden = true; // this variant isn't in VP → no badge, theme renders normal price
      }
    });
  }
  // Capture phase so we mutate detail.variant before the theme's (bubble) price handlers read it.
  document.addEventListener('variant:change', onVariantChange, true);

  // ---- Badge styling, once ----------------------------------------------------------------------
  function injectStyle() {
    if (document.getElementById('vp-member-price-style')) return;
    var s = document.createElement('style');
    s.id = 'vp-member-price-style';
    s.textContent =
      'vp-member-price{display:inline-flex;align-items:center;margin-inline-start:.5rem;vertical-align:middle;}' +
      '.vp-member-price__badge{display:inline-block;padding:.1rem .4rem;border-radius:4px;' +
      'background:rgb(28,28,28);color:#fff;font-size:.72rem;font-weight:600;line-height:1.4;letter-spacing:.02em;}' +
      'a.vp-member-price__badge--link{text-decoration:none;cursor:pointer;}' +
      '.vp-member-price__badge[hidden]{display:none;}' +
      /* Plus petit en mode grille/carte (collection) ; taille normale sur la fiche produit. */
      '.vp-member-price--card{margin-inline-start:.35rem;}' +
      '.vp-member-price--card .vp-member-price__badge{font-size:.66rem;padding:.07rem .35rem;letter-spacing:.01em;}';
    document.head.appendChild(s);
  }

  function init() { injectStyle(); revealPreview(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', revealPreview);
})();
